import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mzc-pdc/ui";
import { useTranslation } from "react-i18next";

const DialogDelete = ({ items, title, contents, actionButtonTitle, actionPending, onClickSubmit, onClickClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog variant={"basic"} open>
            <DialogTitle>
                {title ? title : t(`common::label::Delete ${items.length > 1 ? "items" : "the item"}?`)}
            </DialogTitle>
            <DialogContent children={contents} />
            <DialogActions>
                <Button variant={"text"} color={`grey`} onClick={() => onClickClose()}>
                    {t("common::label::Cancel")}
                </Button>
                <Button
                    variant={`contained`}
                    disabled={actionPending}
                    loading={actionPending}
                    onClick={(e) => {
                        e.stopPropagation();
                        onClickSubmit();
                    }}
                    color={`error`}
                >
                    {t(`common::label::${actionButtonTitle ?? "Delete"}`, `${actionButtonTitle ?? "Delete"}`)}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DialogDelete;
